import { httpClient } from '@bcba/client-auth';
import {
  ExplorerCropPledgeListCreditorSerializer,
  PaginationSerializer,
} from '@bcba/serializers';
import { baseCropPledgePath } from '.';
import { GetPaginatedCropPledgesDto } from './dto/queryParams';

export const getDebtorCropPledge = async (
  params: GetPaginatedCropPledgesDto,
): Promise<PaginationSerializer<ExplorerCropPledgeListCreditorSerializer>> => {
  const { data } = await httpClient.get(`${baseCropPledgePath}/debtors`, {
    params,
  });

  return data;
};

export default getDebtorCropPledge;
